import React from 'react';
import { Grid, Typography, Box, Container } from '@mui/material';

import '../styles/about.css';
import Footer from './Foot';
import SeeMoreBtn from './SeeMoreBtn'

const About = () => {
	return (
		<>
			<Grid
				// className="about"
				container
				height="fit-content"
				justifyContent="center"
				alignItems="flex-start"
				style={{ background: 'hsla(205, 100%, 52%, 0.58)', paddingTop: '5em' }}
			>
				<Box
					sx={{
						color: 'White',
						// background: 'hsl(0, 0%, 41%)',
						width: 'fit-content',
						padding: '1em',
						
					}}
				>
					<Typography variant="h4">
						YECO CANADA
						<Typography variant="h6">About Us</Typography>
					</Typography>
				</Box>

				<Grid
					container
					// className="about"
					

					sx={{
						background: '',
						color: 'white',
						gap: '25px',
						justifyContent: 'flex-start',
						alignItems: 'center',
						flexDirection: 'column',
						width: '100%',
						height: 'fit-content',
						paddingTop:".5em",
						marginBottom:"1em",
					}}
				>
					<Grid item   justifyContent="center" sx={{ background: 'hsla(360, 100%, 100%, 0.73)', width:"60%" }}>
						<Typography
							variant="h6"
							fontFamily="epilogue"
							sx={{ margin: '', color: 'black',
							// background: 'rgb(0,0,0,.5)',
							height:"fit-content",
							padding:"2em",
							 }}
						>
							Mission<Typography variant='subtitle2' >To create a positive change among the youth.</Typography>
						</Typography>
						
					</Grid>

					<Grid item   justifyContent="center" sx={{background: 'hsla(360, 100%, 100%, 0.73)', width:"60%" }}>
						<Typography
							variant="h6"
							fontFamily="epilogue"
							sx={{ margin: '', color: 'black',
							// background: 'rgb(0,0,0,.5)',
							height:"fit-content",
							padding:"2em",
							 }}
						>
							Vision<Typography variant='subtitle2' >To see and positively contribute to a safe community.</Typography>
						</Typography>
						
					</Grid>

					<Grid item   justifyContent="center" sx={{background: 'hsla(360, 100%, 100%, 0.73)', width:"60%" }}>
						<Typography
							variant="h6"
							fontFamily="epilogue"
							sx={{ margin: '', color: 'black',
							// background: 'rgb(0,0,0,.5)',
							height:"fit-content",
							padding:"2em",
							 }}
						>
							Our Value<Typography variant='subtitle2' >{`CARE stands for: Curiosity Accessibility
Reliability and
Engagement`}</Typography>
						</Typography>
						
					</Grid>
					
					<Grid item   justifyContent="center" sx={{ background: 'hsla(360, 100%, 100%, 0.73)', width:"60%" }}>
						<Typography
							variant="h6"
							fontFamily="epilogue"
							sx={{ margin: '', color: 'black',
							// background: 'rgb(0,0,0,.5)',
							height:"fit-content",
							padding:"2em",
							 }}
						>
							Our History<Typography variant='subtitle2' >
							<SeeMoreBtn>
							Youth Engagement and Community Outreach (YECO) is a grassroots group
initially established on WhatsApp in January 2021 as a dialogue forum for issues related to gun
violence. Most of the group have lost close relatives or friends to homicide; they understand the
trauma of gun violence infused into the community. Mobilized from various newcomer communities in Ottawa, these 20 young people were ready to
engage other youth in a conversation on coping with the negative impact of gun violence. For
several months after a first official meeting online in March 2021, the initial group reached out to
their peers through promotions for COVID-19 vaccinations, online church services and video
games and community events. Early in 2022, YECO started creating its social media presence on Instagram, Facebook and
Snapchat. Supported by the Social Planning Council of Ottawa, YECO organized on August 7, 2022, a
Town Hall Meeting at the Bronson Center brought together 25 youth for a panel discussion on
the impact of, and community response to gun violence.Recognizing its increasing strength, YECO has formalized its commitment to mitigating the
effects on youth of gun violence on the streets of Ottawa. The group resolved to help Black,
racialized and newcomer youth integrate into communities that are safe and healthy. To do this,
YECO seeks funding for proven programs that engage, educate and support at-risk youth,
equipping them to contribute to a safe community.
</SeeMoreBtn>
							
							</Typography>
						</Typography>
						
					</Grid>
					
				</Grid>
			</Grid>
			<Footer sx={{background:"white"}} />
		</>
	);
};

export default About;
